const allowRoles = ['SUPER', 'MOVEPRO_ADMIN', 'DEVELOPER'];

export default [
    {
        path: '/migration',
        name: 'Migration',
        meta: {
            requiresAuth: true,
            allowRoles,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Migration',
        },
        components: {
            default: () => import('@views/migration/MigrationIndex.vue'),
        },
    },
    {
        path: '/migration/:workbookId',
        name: 'MigrationShow',
        props: {
            default: (route) => ({ workbookId: route.params.workbookId }),
        },
        meta: {
            requiresAuth: true,
            allowRoles,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Migration',
        },
        components: {
            default: () => import('@views/migration/MigrationShow.vue'),
        },
    },
    {
        path: '/tenants/:tenantId/migration/batches/:batchId/preview',
        name: 'TenantMigrationPreview',
        props: {
            default: (route) => ({
                tenantId: route.params.tenantId,
                batchId: route.params.batchId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Migration Preview',
        },
        components: {
            default: () => import('@views/migration/MigrationPreview.vue'),
        },
    },
    {
        path: '/tenants/:tenantId/migration/workbooks/:workbookId/preview',
        name: 'TenantMigrationWorkbookPreview',
        props: {
            default: (route) => ({
                tenantId: route.params.tenantId,
                workbookId: route.params.workbookId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Migration Preview',
        },
        components: {
            default: () => import('@views/migration/MigrationWorkbookPreview.vue'),
        },
    },
];
